import React from 'react';
import './ServerError.css';

const UnderConstruction =(props) => {
        return (
            <div className="server-error-page">
                <h1 className="server-error-title">
                    Under сonstruction
                </h1>
                <div className="server-error-desc">
                    Упс! Сайт на реконструкции. Попробуйте позднее.
                </div>
            </div>
        );
}

export default UnderConstruction;